<template>
<!-- data-aos="fade" -->
  <div id="app">
    
    <Welcome/>
    <Projects/>
    <Experience/>    
    <Footer/>
  </div>
</template>

<script>
import Welcome from './components/Welcome.vue'
import Experience from './components/Experience.vue'
import Projects from './components/Projects.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Welcome,
    Experience,
    Projects,
    Footer
  }
}


</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap');
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body{
    margin: 0;
    padding: 0;
    font-family: 'Balsamiq Sans', cursive;
}
h2{
  font-family: 'Balsamiq Sans', cursive;
  color: #666!important;
}
h3{
  font-family: 'Balsamiq Sans', cursive;
  font-size: 2.2em;
  line-height: 1.5em;
  font-weight: 400;
  margin-bottom: 50px;
}
h4{
  font-family: 'Balsamiq Sans', cursive;
  font-size: 2em;
  line-height: 1.5em;
  margin: 50px;
}
h6{
  margin: 30px;
}
p{
  font-family: 'Balsamiq Sans', cursive;
  font-size: 1.5em;
      margin-top: 20px;
 }
 .v-application--wrap{
   min-height: 0;
 }
</style>
